import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

let uid = 0;

/**
 * La marca, en vectores y con sus dos estados de movimiento.
 *
 * `--intro` arma la red nodo a nodo y después revela el logotipo; `--loading`
 * hace que la señal recorra la red en bucle. Los dos animan propiedades
 * distintas (transform/opacity frente a fill-opacity), así que conviven.
 *
 * El PNG que había antes no servía para esto: no se puede animar por nodo y
 * lleva la tinta quemada, así que sobre fondo oscuro desaparece. Aquí el color
 * sale de `--dxc-brand-*` y sigue al tema.
 */
@Component({
    standalone: true,
    selector: 'dxc-brand',
    templateUrl: './dxc-brand.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DxcBrandComponent {

    /** Alto del símbolo en px. Todo lo demás — logotipo, hueco, desplome — se deriva de él. */
    @Input() size = 44;
    /** Entrada: la red se arma una vez. */
    @Input() intro = false;
    /** Espera: la señal recorre la red mientras algo carga. */
    @Input() loading = false;
    /** Vacío cuando el texto contiguo ya nombra la marca. */
    @Input() ariaLabel = '';

    /** El degradado se referencia por id, así que cada instancia necesita el suyo. */
    readonly rampId = `dxc-brand-ramp-${++uid}`;
}
